/* eslint-disable react/prop-types */

import React, { useContext, useEffect, useState } from 'react';
import AppContext from 'context/Context';
import SDKanbanContainer from './SDKanbanContainer';
import SDKanbanProvider from './SDKanbanProvider';
import SDPageHeader from '../SDPageHeader';
import { sdCreateRequest, sdMakeRequests, sdRequestsCompleted, sdRenderLoadingOrError, sdGetSelectedProjectId, sdSetSelectedProjectId } from "helpers/sdHelper";
import { sdGetProjects, sdGetBoardForProject, sdGetMe } from "services/service-desk/sdService";

const SDKanban = () => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [me, setMe] = useState(null);
  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(sdGetSelectedProjectId());
  const [boardItems, setBoardItems] = useState([]);

  const {
    config: { isFluid, isNavbarVerticalCollapsed },
    setConfig
  } = useContext(AppContext);
  const [kanbanIsFluid] = useState(isFluid);
  const [kanbanIsNavbarVerticalCollapsed] = useState(isNavbarVerticalCollapsed);

  useEffect(() => {

    let allRequests = [
      sdCreateRequest(() => sdGetProjects(), setProjects),
      sdCreateRequest(() => sdGetMe(), setMe),
      sdCreateRequest(() => sdGetBoardForProject(selectedProjectId), setBoardItems),
    ];

    sdMakeRequests(allRequests, setLoading, setError);

    setConfig('isFluid', true);
    setConfig('isNavbarVerticalCollapsed', true);

    return () => {
      setConfig('isFluid', kanbanIsFluid);
      setConfig('isNavbarVerticalCollapsed', kanbanIsNavbarVerticalCollapsed);
    };
  }, []);

  // useEffect(() => {
  //   sdGetBoardForProject(selectedProjectId).then(res => {
  //     setBoardItems(res.data);
  //   }).catch(err => {
  //     console.log(err);
  //   }).finally(() => {
      
  //   })
  // }, [selectedProjectId]);

  if (!sdRequestsCompleted(loading, error)) {
    return sdRenderLoadingOrError(loading, error);
  }

  return (
    <>
      <SDKanbanProvider boardItems={boardItems}>
        <SDPageHeader title="Kanban Board" me={me} projects={projects} selectedProjectId={selectedProjectId} onProjectChanged={(id) => { setSelectedProjectId(id); sdSetSelectedProjectId(id); window.location.reload(); }} showCreateIssue></SDPageHeader>
        {/* <SDKanbanHeader /> */}
        <SDKanbanContainer />
      </SDKanbanProvider>
    </>
  );
};

export default SDKanban;
